import React from 'react'
import { NavLink } from 'reactstrap'
const upToDate = [
  {
    id: 1,
    img: `${process.env.REACT_APP_CDN_URL}/wordpress/2021/09/02160501/Trust-score-grow-your-business-with-TS.png`,
    title: " How can you grow your business with Trust Score? ",
    date: "August 30, 2021",
    url: `https://about.crediwatch.com/resources/blog/msme/how-can-you-grow-your-business-with-trust-score/`
  },
  {
    id: 2,
    img: `${process.env.REACT_APP_CDN_URL}/wordpress/2021/09/02174904/Credit-growth-vs-Credit-Risk.png`,
    title: " The banking conundrum: Balancing credit growth vs credit risk ",
    date: "September 2, 2021",
    url: `https://about.crediwatch.com/resources/insights/the-banking-conundrum-balancing-credit-growth-vs-credit-risk/`
  },
];
const KeepUptoDate = () => {
  return (
    <>
      <div>
        <div className='text-center'>
          <h2 className="businessTitle text-center ff-renner-bold">
            Keep up to date with Crediwatch
          </h2>
          <div className='align-self-center d-flex justify-content-center'>
            <div className='line text-primary bg-primary mt-4' />
          </div>
        </div>
        <div className='row mt-4 justify-content-center'>
          {upToDate.map(each => {
            return (
              <div className="col-lg-5 col-12 bg-white" key={each.id}>
                <div className='card m-3'>
                  <div className="card-body pt-0">
                    <img className="card-img-top mb-2 p-3" src={each.img} alt="Card image cap" />
                    <p className="upToDate-title card-text h5">{each.title}</p>
                    <div className='mb-5'>
                      <i className='fas fa-calendar-alt'></i>
                      <span className='upToDate-date'> {each.date}</span>
                    </div>
                    <NavLink href={`${each.url}`} className="upToDate-info p-0 fs-16 text-primary mt-3">Read More --&gt;</NavLink>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
export default KeepUptoDate



